import { render, staticRenderFns } from "./ProtocolCard.vue?vue&type=template&id=3c0b12d2&scoped=true"
import script from "./ProtocolCard.vue?vue&type=script&lang=js"
export * from "./ProtocolCard.vue?vue&type=script&lang=js"
import style0 from "./ProtocolCard.vue?vue&type=style&index=0&id=3c0b12d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0b12d2",
  null
  
)

export default component.exports